
export const apartmentMixin = {
  computed: {
    apartment() {
      return this.reservation ? this.reservation.apartment : null
    },
    apartment_city_name() {
      return this.apartment && this.apartment.city ? this.apartment.city.name : null
    },
    apartment_place() {
      return this.apartment ? [
        this.apartment.street,
        this.apartment.street_number,
        this.apartment_city_name,
      ].join(' ') : ''
    },
    apartment_name() {
      return `${this.apartment.name}, ${this.apartment_city_name}`
    },
    apartment_link() {
      return this.apartment ? `<a href="${this.$store.state.application.urls.apartment_url.replace(':id', this.apartment.id)}" target="_blank">${this.apartment_name}</a>` : ''
    },
    apartment_image() {
      return (!!this.apartment && !!this.apartment.image && !this.apartment.image.includes('local') ) ? this.apartment.image : this.default_apartment_image
    },
    default_apartment_image() {
      return require('../assets/default_apartment.jpg')
    },
    apartment_promo_document() {
      return !!this.apartment && this.apartment.promo_document
    },
    apartment_reception() {
      return !!this.apartment ? this.apartment.reception : null
    },
    apartment_reception_place() {
      if (!!this.apartment && !!this.apartment.reception)
        return [this.apartment_reception.street, (this.apartment_reception.city ? this.apartment_reception.city.name : null)].join(' ')
    },
  },
}
